export default __webpack_public_path__ + "static/media/logoooo.146dd904.png";